import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Grid, Button } from '@mui/material';

//pacote deprecated
// import { SortableContainer, SortableElement } from 'react-sortable-hoc';

// import { moveElement } from 'js/library/utils/helpers';
// import placeholder from 'styles/assets/placeholder/placeholderCard.gif';
// import { downloadImage } from 'js/library/services/StorageManager';
import updateCard from 'js/library/utils/API/updateCard';
import { useState } from 'react';

export default function EditCards(props) {
  const [items] = useState(props.cards);
  // const [cardScroll, setCardScroll] = useState(0);
  const handleEdit = props.handleEdit;
  const cardPriority = props.cards.length > 0 ? Math.floor(props.cards[0].priority / 100) : 0;
  const { t } = useTranslation();

  // const downloadImageCard = (data, i) => {
  //   if (data !== undefined && data !== null && data.downloaded === undefined) {
  //     const image = data.image.split('/');

  //     downloadImage(image[0], image[1])
  //       .then((downloaded) => {
  //         let newItems = [...items];

  //         newItems[i].downloaded = downloaded;

  //         setItems(newItems);
  //       })
  //       .catch((error) => {
  //         return error;
  //       });
  //   }
  // };

  // const saveScrollState = () => {
  //   const cardScroll = document.getElementById('cardList').scrollTop;
  //   setCardScroll(cardScroll);
  // };

  // const loadScrollState = () => {
  //   document.getElementById('cardList').scrollTop = cardScroll;
  // };

  // const onSortCardEnd = ({ oldIndex, newIndex }) => {
  //   saveScrollState();

  //   setItems(moveElement(items, oldIndex, newIndex));

  //   loadScrollState();
  // };

  const savePriority = () => {
    let finalList = [];
    let newItems = [...items];

    const keywordCounter = cardPriority * 100;

    newItems.map((item, i) => {
      item.priority = keywordCounter + i;
      return finalList.push(item);
    });

    finalList.map((item) => {
      return updateCard(props, item.cardId, { priority: item.priority });
    });

    handleEdit(null);
  };

  // const SortableItem = SortableElement(({ value }) => {
  //   const i = value.i;
  //   value = value.value;
  //   return (
  //     <li key={value.cardId} style={{ listStyleType: 'none', zIndex: 99999999 }}>
  //       <img
  //         key={value.cardId}
  //         src={value.downloaded === undefined ? placeholder : value.downloaded}
  //         alt="Thumb do Card"
  //         width="100%"
  //         onLoad={() => downloadImageCard(value, i)}
  //       />
  //     </li>
  //   );
  // });

  // const SortableList = SortableContainer(() => {
  //   return (
  //     <ul id="cardList">
  //       {items.map((value, i) => {
  //         return <SortableItem key={value.cardId} index={i} value={{ value, i }} />;
  //       })}
  //     </ul>
  //   );
  // });

  return (
    <div>
      <Typography
        style={{ color: '#0089FF', cursor: 'pointer' }}
        variant="body2"
        onClick={() => handleEdit(null)}
      >
        {'<'} {t('organizations.return')}
      </Typography>

      <Typography variant="h6" color="primary" style={{ fontWeight: 'bolder' }}>
        {t('organizations.cards')}
      </Typography>

      <Grid container spacing={4} style={{ width: '100%', marginBottom: '20px' }}>
        <Grid size={{ md: 6, xs: 12 }}>
          <Button
            style={{ textTransform: 'none' }}
            fullWidth
            variant="contained"
            color="secondary"
            onClick={() => handleEdit(null)}
          >
            {t('organizations.cancel')}
          </Button>
        </Grid>
        <Grid size={{ md: 6, xs: 12 }}>
          <Button
            style={{ textTransform: 'none' }}
            fullWidth
            variant="contained"
            color="primary"
            disabled
            onClick={savePriority}
          >
            {t('organizations.save')}
          </Button>
        </Grid>
      </Grid>

      <Typography variant="h6" color="primary" style={{ fontWeight: 'bolder' }}>
        Função em atualização.
      </Typography>

      {/* <SortableList items={items} onSortEnd={onSortCardEnd} /> */}
    </div>
  );
}
